
export default {
  name: 'HeaderAdditionalLink',
  props: {
    link: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    formattedLink() {
      if (!this.link?.href) {
        return '/';
      }
      return this.link.href.startsWith('/') ? this.link.href : `/${this.link.href}`;
    },
  },
};
